// extracted by mini-css-extract-plugin
export default {"headerTitle":"country_headerTitle__uiP61","page":"country_page__JE4LY","header":"country_header__FsJyz","container":"country_container__hOaMA"};